// Get the container
const slideContainer5 = document.querySelector('.slide_container5');

// URLs for desktop images
const desktopImageUrls5 = [
    'https://cdn.shopify.com/s/files/1/0641/0023/7487/files/ASSCWare_Desktop3.gif?v=1723592409',
    'https://cdn.shopify.com/s/files/1/0641/0023/7487/files/ASSCWare_Desktop2.png?v=1723592418',
    'https://cdn.shopify.com/s/files/1/0641/0023/7487/files/ASSCWare_Desktop4.png?v=1723592416'
];

// URLs for mobile images
const mobileImageUrls5 = [
    'https://cdn.shopify.com/s/files/1/0641/0023/7487/files/ASSCWare_Mobile12.png?v=1723592608',
    'https://cdn.shopify.com/s/files/1/0641/0023/7487/files/ASSCWare_Mobile3.png?v=1723592599',
    'https://cdn.shopify.com/s/files/1/0641/0023/7487/files/ASSCWare_Mobile4.png?v=1723592607',
    'https://cdn.shopify.com/s/files/1/0641/0023/7487/files/ASSCWare_Mobile5.png?v=1723592604',
    'https://cdn.shopify.com/s/files/1/0641/0023/7487/files/ASSCWare_Mobile6.png?v=1723592601',
    'https://cdn.shopify.com/s/files/1/0641/0023/7487/files/ASSCWare_Mobile7.png?v=1723592596',
    'https://cdn.shopify.com/s/files/1/0641/0023/7487/files/ASSCWare_Mobile8.png?v=1723592580',
    'https://cdn.shopify.com/s/files/1/0641/0023/7487/files/ASSCWare_Mobile9.png?v=1723592604',
    'https://cdn.shopify.com/s/files/1/0641/0023/7487/files/ASSCWare_Mobile10.png?v=1723592607',
    'https://cdn.shopify.com/s/files/1/0641/0023/7487/files/ASSCWare_Mobile11.png?v=1723592604',
    'https://cdn.shopify.com/s/files/1/0641/0023/7487/files/ASSCWare_Mobile12.png?v=1723592608',
    'https://cdn.shopify.com/s/files/1/0641/0023/7487/files/ASSCWare_Mobile13.png?v=1723592608'
];

// Function to determine screen size and load appropriate images
function loadImages5() {
    const isMobile = window.innerWidth <= 768;
    console.log('isMobile:', isMobile); // Log whether the device is identified as mobile

    // Clear the container
    slideContainer5.innerHTML = '';

    if (isMobile) {
        console.log('Loading mobile images'); // Log the action of loading mobile images
        // Create and append mobile images
        mobileImageUrls5.forEach(url => {
            const mobileImage = document.createElement('img');
            mobileImage.src = url;
            mobileImage.alt = 'Mobile image';
            mobileImage.className = 'mobile-image5';
            slideContainer5.appendChild(mobileImage);
        });
    } else {
        console.log('Loading desktop images'); // Log the action of loading desktop images
        // Create and append desktop images
        desktopImageUrls5.forEach(url => {
            const desktopImage = document.createElement('img');
            desktopImage.src = url;
            desktopImage.alt = 'Desktop image';
            desktopImage.className = 'desktop-image5';
            slideContainer5.appendChild(desktopImage);
        });
    }
}

// Call the function initially
document.addEventListener("DOMContentLoaded", function() {
    loadImages5();
    // Listen for window resize events to update images if necessary
    window.addEventListener('resize', loadImages5);

    // Set the target end time (June 6, 2024, at 11:00 AM ET)
    const targetEndTime5 = new Date('2024-06-06T11:00:00-04:00').getTime();

    function updateCountdown5() {
        const currentTime = new Date().getTime();
        const timeDifference = targetEndTime5 - currentTime;

        // Check if the countdown has ended
        if (timeDifference <= 0) {
            document.getElementById('countdown5').textContent = "Ready!";
            return;
        }

        const hours = Math.floor(timeDifference / (1000 * 60 * 60));
        const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

        document.getElementById('countdown5').textContent = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;

        setTimeout(updateCountdown5, 1000);
    }

    updateCountdown5();
});
